import { jsx as r, jsxs as i, Fragment as u } from "react/jsx-runtime";
import { message as x } from "../../queries/message/index.js";
import { contact as M } from "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { c as T, C as y } from "../../index-DNTqwtVt.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { useApp as w } from "../../context/app/index.js";
import { useTitle as k } from "../../context/metadata/title.js";
import { Box as n, Alert as c, Link as I } from "@mui/material";
import { useEffect as C } from "react";
import { Thread as D } from "./components/Thread.js";
import { MessageDetails as j } from "./components/MessageDetails.js";
const se = ({
  messageId: o,
  onMessageClick: p,
  onMessageSent: d,
  pageContainer: a = n,
  showLatestMessageAlert: h = !0
}) => {
  var l;
  k("Message");
  const { data: e, isPending: g, error: t } = new x.thread({ messageId: o }).ToQuery(), { isPending: f, data: s } = new M.currentUser().ToQuery(), { mainEl: m } = w();
  return C(() => {
    m && e && s && (m.scrollTop = m.scrollHeight);
  }, [e, s]), t ? /* @__PURE__ */ r(a, { children: /* @__PURE__ */ i(c, { severity: "error", children: [
    /* @__PURE__ */ r("p", { children: t.title }),
    t.detail && /* @__PURE__ */ r("p", { children: t.detail })
  ] }) }) : /* @__PURE__ */ r(a, { sx: { display: "flex", flexFlow: "column", gap: 2, justifyContent: "space-between" }, children: g || f ? /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(T, {}) }) : /* @__PURE__ */ i(u, { children: [
    /* @__PURE__ */ i(n, { display: "flex", flexDirection: "column", gap: 1, children: [
      (e == null ? void 0 : e.messages.length) > 0 && /* @__PURE__ */ r(j, { message: e.messages[0] }),
      /* @__PURE__ */ r(D, { messages: e.messages, currentUser: s, threadId: o, onMessageClick: p }),
      h && e.latestMessageId > 0 && e.latestMessageId !== o && /* @__PURE__ */ i(c, { severity: "warning", children: [
        "This is not the latest message in the conversation. Click ",
        /* @__PURE__ */ r(I, { onClick: () => p(e.latestMessageId), sx: { cursor: "pointer" }, children: "here" }),
        " to open the most recent"
      ] })
    ] }),
    /* @__PURE__ */ r(y, { actionsMask: e.actionMask, threadID: (l = e == null ? void 0 : e.messages[0]) == null ? void 0 : l.ThreadID, onMessageSent: d })
  ] }) });
};
export {
  se as MessageThreadView
};
//# sourceMappingURL=MessageThreadView.js.map
